var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-overlay',{staticClass:"align-center justify-center",model:{value:(_vm.overlay),callback:function ($$v) {_vm.overlay=$$v},expression:"overlay"}},[_c('lottie-animation',{attrs:{"path":'lottie/loader.json',"width":300,"height":300,"speed":1}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }